import { render, staticRenderFns } from "./SetupCode.vue?vue&type=template&id=28accfea&scoped=true"
import script from "./SetupCode.vue?vue&type=script&lang=js"
export * from "./SetupCode.vue?vue&type=script&lang=js"
import style0 from "./SetupCode.vue?vue&type=style&index=0&id=28accfea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28accfea",
  null
  
)

export default component.exports